import { TuiAppBar } from '@taiga-ui/layout';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiIcon, TuiButton } from '@taiga-ui/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'x-icon-button',
  imports: [SvgIconComponent, CommonModule, TuiAppBar, TuiButton, TuiIcon],
  templateUrl: './icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  $iconName = input.required<string>({ alias: 'iconName' });
  $size = input<number>(42, { alias: 'size' });
  /**
   * Размер глифа Taiga-иконки в px. В v3 `tuiIconXxx` были 16px, а `tuiIconXxxLarge` — 24px;
   * в v5 `tui-icon` по умолчанию 24px, поэтому для бывших «маленьких» иконок передаём 16.
   */
  $iconSize = input<number | null>(null, { alias: 'iconSize' });
  $backgroundPrimary = input<boolean>(false, { alias: 'backgroundPrimary' });
  $clickFunction = input.required<any>({
    alias: 'clickFunction',
  });
  $disabled = input<boolean>(false, {
    alias: 'disabled',
  });

  click(event: MouseEvent): void {
    event.stopPropagation();

    if (this.$disabled()) {
      return;
    }

    this.$clickFunction()();
  }
}
